export const OPEN_HAMBURGER_MENU = "OPEN_HAMBURGER_MENU";
export const OPEN_SEARCHBAR = "OPEN_SEARCHBAR";
export const MEMBER_UPDATED = "MEMBER_UPDATED";
export const IS_OPEN_LOGIN_FORM = "IS_OPEN_LOGIN_FORM";
export const MOVIE_LIST_OK = "MOVIE_LIST_OK";

export const RADIOT_CLICKED = "RADIOT_CLICKED";
export const RADIOT_HELSINKI = "RADIOT_HELSINKI";
export const RADIOT_YLEISOHJELMA = "RADIOT_YLEISOHJELMA";
export const RADIOT_KAJANI = "RADIOT_KAJANI";
export const RADIOT_KEMI = "RADIOT_KEMI";
export const RADIOT_OULU = "RADIOT_OULU";
export const RADIOT_ROVANIEMI = "RADIOT_ROVANIEMI";
export const RADIOT_TORNIO = "RADIOT_TORNIO";
export const RADIOT_TURKU = "RADIOT_TURKU";
export const RADIOT_LAHTI = "RADIOT_LAHTI";
export const RADIOT_KOKKOLA = "RADIOT_KOKKOLA";
export const RADIOT_KRISTIINANKAUPPUNKI = "RADIOT_KRISTIINANKAUPPUNKI";
export const FOOTER_PRIVACY_POLICY = "FOOTER_PRIVACY_POLICY";
export const FOOTER_OHJEET_JA_APUA = "FOOTER_OHJEET_JA_APUA";
export const FOOTER_TILAUS_JA_OHJEET = "FOOTER_TILAUS_JA_OHJEET";
export const FOOTER_LIITANAISET = "FOOTER_LIITANAISET";
export const FOOTER_ASIAKASPALVELU = "FOOTER_ASIAKASPALVELU";
export const RESET_ALL_RADIO_PLAYERS = "RESET_ALL_RADIO_PLAYERS";
